import { render, staticRenderFns } from "./CargarUsuario.vue?vue&type=template&id=08b48bc8&"
import script from "./CargarUsuario.vue?vue&type=script&lang=js&"
export * from "./CargarUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports